import { SITE_MAP } from "../actionType";

export const sitemapDataRequest = () => ({
    type: SITE_MAP.LOAD,
})